import { render, staticRenderFns } from "./FundingDetailsBankStatementData.vue?vue&type=template&id=5061c00a&scoped=true&"
import script from "./FundingDetailsBankStatementData.vue?vue&type=script&lang=js&"
export * from "./FundingDetailsBankStatementData.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetailsBankStatementData.vue?vue&type=style&index=0&id=5061c00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061c00a",
  null
  
)

export default component.exports